<template>
  <div>
    <TableCompanyReports />
    <ModalCompanyReportAccess />
  </div>
</template>

<script>
import Vue from 'vue'
import { defineComponent, onUnmounted } from '@vue/composition-api'
import { createVuexHelpers } from 'vue2-helpers'

import { useDOMPageTitle } from '@composables'
import TableCompanyReports from '@components/TableCompanyReports'
import ModalCompanyReportAccess from '@components/ModalCompanyReportAccess'

export default defineComponent({
  name: 'ManageCompanyReports',
  components: {
    TableCompanyReports,
    ModalCompanyReportAccess
  },
  setup() {
    const { setDOMPageTitle } = useDOMPageTitle()

    const { useGetters } = createVuexHelpers()

    const { company } = useGetters(['company'])

    setDOMPageTitle(company.value.name || '')

    onUnmounted(() => {
      Vue.prototype.$bus.destroyEvents()
    })

    return {}
  }
})
</script>
